import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandTeamMemberRemoveFromTeamPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandTeamMemberRemoveFromTeamProperties = {
    [name in keyof EntityCommandTeamMemberRemoveFromTeamPropertyValues]: Property<EntityCommandTeamMemberRemoveFromTeamPropertyValues[name]>
};

export interface IEntityCommandTeamMemberRemoveFromTeam extends IEntityCommand, EntityCommandTeamMemberRemoveFromTeamProperties
{
}

// #region Auto Generated

export const
    EntityCommandTeamMemberRemoveFromTeamClassFullName = "@greg-brandon/escorting-officer-coordinator/EntityCommands/EntityCommandTeamMemberRemoveFromTeam.EntityCommandTeamMemberRemoveFromTeam";

// #endregion

export class EntityCommandTeamMemberRemoveFromTeam extends EntityCommand implements IEntityCommandTeamMemberRemoveFromTeam
{
    // #region Static

    // #region Properties

    public static override classNamespace = NAMESPACE + "EntityCommandTeamMemberRemoveFromTeam";
    public static override className = "EntityCommandTeamMemberRemoveFromTeam";

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandTeamMemberRemoveFromTeamPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Remove from team",
                entityName: "TeamMember",
                key: "REMOVE_FROM_TEAM",
                permission: PermissionEvaluator.permissionLevels.delete,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected messageDialog?: MessageDialog;

    // #endregion

    // #region Constructors

    constructor(propertyValues?: PartialNullable<EntityCommandTeamMemberRemoveFromTeamPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        const
            self = this;

        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    if (!self.messageDialog)
                        self.messageDialog = new MessageDialog();

                    const
                        entitySetName = entityCommandInformation.entitySetName.get(),
                        record = entityCommandInformation.record.get();

                    if (!entitySetName)
                        return;

                    if (!record || !record.id)
                        return;

                    let
                        teamName = "the team",
                        memberName = "the user";

                    if (record)
                    {
                        if (record.team?.name)
                            teamName = "the team \"" + record.team.name + "\"";

                        if (record.memberTeam?.name)
                            memberName = "the team \"" + record.memberTeam.name + "\"";
                        else if (record.memberUser?.username)
                            memberName = "the user \"" + record.memberUser.username + "\"";
                    }

                    self.messageDialog.buttonStyle.set(ButtonStyleEnum.yesNo);
                    self.messageDialog.title.set("Remove Member From Team?");
                    self.messageDialog.text.set(StringHelper.format("Are you sure you want to remove {0} from {1}?", memberName, teamName));

                    return (
                        self.messageDialog
                            .openAsync()
                            .then(result =>
                            {
                                if (result.dialogResult === DialogResultEnum.yes)
                                {
                                    return (
                                        ServiceManager.getRequired(WebApiClientService)
                                            .createEntityDeleteRequest(
                                                entitySetName,
                                                record.id
                                            )
                                            .executeAsync()
                                    );
                                }
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

